<template>
  <BaseListItem>
    <RouterLink :to="toProject">
      <div class="flex -mx-4 p-4">
        <div class="w-64 px-4">
          <template v-if="project.cover">
            <img sizes="1px" :src="project.cover" class="block rounded w-full" />
          </template>
          <template v-else>
            <div class="aspect-ratio-16/9 w-full rounded bg-gray-200" />
          </template>
        </div>
        <div class="flex-1 px-4">
          <h1 class="text-base flex justify-between items-baseline">
            {{ project.name }}
            <span
              v-if="project.status"
              class="text-xs inline-flex px-3 py-1 rounded-full leading-3 text-white mt-2 bg-gray-600 capitalize"
              >{{ project.status }}</span
            >
          </h1>
          <h3 v-if="client" class="block text-sm font-medium text-gray-500 pointer-events-none">
            {{ client.name }}
          </h3>
          <p class="text-sm text-gray-600 mt-2">
            <span class="font-medium">Manager:</span> {{ owner ? owner.fullName : '-' }}
          </p>
          <div class="my-2 space-x-2" @click.stop>
            <BaseButton
              tag="RouterLink"
              info
              v-if="project.pendingApprovalRequestsCount"
              :to="toProjectAssets"
            >
              {{ project.pendingApprovalRequestsCount }} Pending Reviews
            </BaseButton>
          </div>
          <p v-if="project.description">
            {{ project.description }}
          </p>
        </div>
      </div>
    </RouterLink>
  </BaseListItem>
</template>

<script>
import { mapState } from 'vuex';
import mediableMixin from '@/mixins/mediableMixin';

const defaultProject = {
  name: 'Project Name',
  description: 'Project Description',
  cover: null,
  accountUuid: null,
};
export default {
  name: 'ListItem',
  mixins: [mediableMixin],
  props: {
    entity: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapState('entities', {
      accounts(state) {
        const { accounts = [] } = this.entity || {};

        if (!Array.isArray(accounts)) {
          return [];
        }

        return accounts.map((id) => state.accounts.byId[id]);
      },
      accountRelation() {
        const { accountRelation } = this.entity;

        if (!accountRelation) {
          return null;
        }

        if (typeof accountRelation === 'object') {
          return accountRelation;
        }

        return this.$store.state.entities.accountRelations.byId[accountRelation];
      },
      owner({ users }) {
        if (!this.project.ownerId) {
          return null;
        }

        return users.byId[this.project.ownerId] || null;
      },
    }),
    project() {
      return { ...defaultProject, ...this.entity };
    },
    client() {
      if (!this.project?.client) {
        return null;
      }

      if (typeof this.project.client === 'object') {
        return this.project.client;
      }

      return this.$store.state.entities.accounts.byId[this.project.client] || null;
    },
    toProject() {
      return {
        name: 'accounts.projects.project',
        params: {
          accountId: this.accountRelation?.relatedAccountUuid || this.entity.accountUuid,
          projectId: this.entity.uuid,
        },
      };
    },
    toProjectAssets() {
      return {
        name: 'accounts.projects.project.assets',
        params: {
          accountId: this.accountRelation?.relatedAccountUuid || this.entity.accountUuid,
          projectId: this.entity.uuid,
        },
      };
    },
  },
};
</script>
